import React from "react";
import clsx from "clsx";
import "./chat-input.styles.scss";
import { useChatBoxViewContext } from "../../contexts";

export interface ChatInputProps {
	className?: string;
	chatInputValue?: string;
	onKeyDownChatInput?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
	onChatInputChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const BlockName = "chat-input";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {
		CoreInput: `${BlockName}__core-input`,
	},
} as const;

export type ChatInputComponent = React.FC<ChatInputProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatInput = (props: ChatInputProps) => {
	const { fromUidInfo } = useChatBoxViewContext();
	return (
		<div className={clsx(ChatInput.ClassNames.Block, props.className)}>
			<input
				className={ChatInput.ClassNames.Elements.CoreInput}
				type="text"
				placeholder={`Nhập @, tin nhắn tới ${fromUidInfo.name}`}
				value={props.chatInputValue}
				onChange={props.onChatInputChange}
				onKeyDown={props.onKeyDownChatInput}
			/>
		</div>
	);
};
ChatInput.ClassNames = ClassNames;
